import {ContentHomeDetailInfo} from '../../../../graphql/generated/types';
import {SeparatorType} from '../../../atoms/Separator/SeparatorType.enum';
import {Text} from '../../../atoms/Text/Text';
import {TextsWithSeparator} from '../../../molecules/TextsWithSeparator/TextsWithSeparator';

export interface DetailInfoProps {
  infoList: ContentHomeDetailInfo[];
}

export function DetailInfo({infoList}: DetailInfoProps) {
  return (
    <div className="flex w-full flex-col items-start px-18pxr pb-18pxr">
      {infoList.map((info, index) => (
        <div
          key={`detail-info-${index}`}
          className="font-small1 flex w-full pt-6pxr"
        >
          <Text className="mr-8pxr inline-block w-62pxr shrink-0 text-ellipsis text-theme-solid-60 line-clamp-1">
            {info.title}
          </Text>
          {info.info && info.info.length > 1 ? (
            <TextsWithSeparator
              texts={info.info as string[]}
              separatorType={SeparatorType.ContentHomeLine}
              className="text-theme-solid-100"
            />
          ) : (
            <Text className="text-theme-solid-100 break-word-anywhere">
              {info.info}
            </Text>
          )}
        </div>
      ))}
    </div>
  );
}
